'use es6';

export const get = (spec, config) => {
  const {
    limit
  } = config;
  return {
    limit
  };
};